<template>
  <v-container fluid fill-height>
    <v-layout align-start justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Ustaw nowe hasło</v-toolbar-title>
          </v-toolbar>
          <form class="login" @submit.prevent="passwordReset" novalidate>
          <v-card-text>
            <v-alert
              :value="error || this.formErrors.token"
              type="error"
            >
              Podany link do resetu hasła nie istnieje
            </v-alert>
            <v-alert
              :value="validation.hasError('passwordData.non_field_errors')"
              type="error"
            >
              <span v-for="error in validation.allErrors('passwordData.non_field_errors')">{{error}}</span>
            </v-alert>
              <v-text-field
                prepend-icon="lock"
                v-model="passwordData.new_password1"
                :error-messages="validation.allErrors('passwordData.new_password1')"
                name="password"
                label="Hasło"
                id="password"
                type="password"></v-text-field>
              <v-text-field
                prepend-icon="lock"
                v-model="passwordData.new_password2"
                :error-messages="validation.allErrors('passwordData.new_password2')"
                name="password"
                label="Powtórz hasło"
                id="password"
                type="password"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="submit" color="primary">Ustaw nowe hasło</v-btn>
          </v-card-actions>
          </form>
          <v-progress-linear v-if="progress" :indeterminate="true"></v-progress-linear>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {passwordResetConfirm} from './api'
import {Validator} from 'simple-vue-validator'
import {serverValidation} from '@/utils/form-utils'
import iziToast from 'izitoast'

export default {
  validators: {
    'passwordData.new_password1': function (value) {
      value = value || null
      return Validator.value(value).custom(serverValidation(this.formErrors, 'new_password1'))
    },
    'passwordData.new_password2': function (value) {
      value = value || null
      return Validator.value(value).custom(serverValidation(this.formErrors, 'new_password2'))
    }
  },
  data () {
    return {
      formErrors: {},
      progress: false,
      passwordData: {
        token: this.$route.params.token,
        uid: this.$route.params.uidb64
      },
      error: false
    }
  },
  methods: {
    passwordReset () {
      this.$validate().then(success => {
        if (success) {
          passwordResetConfirm(this.passwordData).then((data) => {
            iziToast.show({
              message: 'Hasło zostało ustawione. Można zalogować się.',
              color: 'green'
            })
            this.$router.push({name: 'login'})
            return data
          }).catch((data) => {
            if (data.response.status === 404) {
              this.error = true
            }
            if (data.response.status === 400) {
              this.formErrors = data.response.data
              this.$validate()
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/auth/PasswordResetConfirm.vue